import dayjs from "dayjs";
import { defaultDateFormatDDMMYYYYSeperatedBySlash, ensureDateOrUndefined } from "../Utils/dates";

export const lastUpdatedTimeStamp = (lastUpdated: string | undefined) => {
  return (
    <>
      <span>Last Updated: </span>
      {lastUpdated ? (
        <span>
          {dayjs(lastUpdated).format(defaultDateFormatDDMMYYYYSeperatedBySlash)}{" "}
          {ensureDateOrUndefined(lastUpdated)?.toLocaleTimeString()}
        </span>
      ) : (
        <span>No last update time found</span>
      )}
    </>
  );
};
